/**
 * created by wang lei
 无序列表
 *
 */
import React, {Component} from 'react';
import listBottom from "./listBottom.png"
import SelectTool from "../components/selectTool";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class ListBottomTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options:[
                {key:'circle', val:'小圆圈', checked: false},
                {key:'disc', val:'小黑点', checked: false},
                {key:'square', val:'小方块', checked: false},
            ],
            defaultOption: 'circle',
            listBottom:false,
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let ulKey = this.props.editor.queryCommandValue("insertunorderedlist"); // circle,disc,square,dash,dot
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.setState({listBottom: ulKey !== null});
    }
    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let ulKey = this.props.editor.queryCommandValue("insertunorderedlist"); // circle,disc,square,dash,dot
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.selectTool.hide();
        this.setState({listBottom: ulKey !== null});
    }

    render() {
        let style = {};
        if(this.state.listBottom){
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return <div style={{display: 'inline-block'}}>
            <div className={"editor-insert-unordered-list-tool-btn"} style={style}>
            <SelectTool
                ref={ref => this.selectTool = ref}
                editor={this.props.editor}
                options={this.state.options}
                defaultOption={'circle'}
                configKey={'insertunorderedlist'}
                imgUrl={listBottom}
                onClickCall={(data) => {
                    if (data) {
                        this.setState({listBottom: !this.state.listBottom})
                    }
                }}
            /></div>
            <style>{`
                .editor-insert-unordered-list-tool-btn{
                    border: 1px solid #f2f6fc;
                    margin-top: 5px;
                    line-height: 1.5
                }
                .editor-insert-unordered-list-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-insert-unordered-list-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
        </div>
    }

}
